const $ = window.jQuery || {};

class Whatsapp {
  constructor(phoneNumber) {
    this.phoneNumber = phoneNumber.replace(/[^0-9]/g, "");
    this.buttonElement = null;
    this.init();
  }

  init() {
    this.createButton();
    this.attachEventListeners();
  }

  createButton() {
    const websiteUrl = window.location.href;
    const button = $("<div>", {
      class: "lightglobal-forward--whatsapp",
      html: `
        <a href="https://wa.me/${this.phoneNumber}" target="_blank" rel="noopener noreferrer" class="lightglobal-forward--whatsapp__link">
          <img src="${websiteUrl}wp-content/plugins/lightglobal-forward/img/whatsapp.png" alt="WhatsApp" class="lightglobal-forward--whatsapp__icon">
        </a>
      `,
    });

    $("body").append(button);
    this.buttonElement = button;
  }

  attachEventListeners() {
    $(window).on("scroll", () => {
      const scrollPosition = $(window).scrollTop();
      const windowHeight = $(window).height();
      const documentHeight = $(document).height();
      const scrollPercentage =
        (scrollPosition / (documentHeight - windowHeight)) * 100;

      if (scrollPercentage > 0) {
        this.buttonElement.css("opacity", "0.5");
      } else {
        this.buttonElement.css("opacity", "1");
      }
    });
  }
}

export default Whatsapp;
